/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var AgentBillPaymentImportRow;

(function (_AgentBillPaymentImportRow) {
  var status;

  (function (status) {
    status["IMPORTED"] = "imported";
    status["ALREADY_SETTLED"] = "already_settled";
    status["SKIPPED"] = "skipped";
    status["FAILED"] = "failed";
  })(status || (status = {}));

  _AgentBillPaymentImportRow.status = status;
})(AgentBillPaymentImportRow || (AgentBillPaymentImportRow = {}));